import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";

/** @jsxImportSource @emotion/react */
import { Typography } from "@vc-workspace/utils-typography";
import { containerStyles, contentContainer, imageStyles, contentGridContainer, contentGridItemContainer, contentGridItemImage } from './maker-selling-categories.module.style';
export function MakerSellingCategories(props) {
  return _jsxs("div", {
    css: containerStyles,
    children: [_jsxs("picture", {
      children: [_jsx("source", {
        srcSet: "/_mp-images/selling_categories_bg.webp",
        type: "image/webp"
      }), _jsx("img", {
        src: "/_mp-images/selling_categories_bg.png",
        css: imageStyles
      })]
    }), _jsxs("div", {
      css: contentContainer,
      children: [_jsx(Typography, {
        type: props.context.isMobileView ? "Headline_H1" : "Heading2",
        color: "white",
        className: "text-center",
        bold: true,
        children: "See what's selling"
      }), _jsx("div", {
        className: "page-container",
        children: _jsx("div", {
          css: contentGridContainer,
          children: DataSet.map(function (item) {
            return _jsxs("div", {
              css: contentGridItemContainer,
              children: [_jsxs("picture", {
                children: [_jsx("source", {
                  srcSet: item.webpUrl,
                  type: "image/webp"
                }), _jsx("img", {
                  src: item.imageUrl,
                  css: contentGridItemImage
                })]
              }), _jsx(Typography, {
                type: props.context.isMobileView ? "Body2" : "Headline_H3",
                color: "white",
                className: props.context.isMobileView ? "pt-2" : "pt-6",
                children: item.title
              })]
            }, item.title);
          })
        })
      })]
    })]
  });
}
var DataSet = [{
  imageUrl: '/_mp-images/OrganicBeauty.png',
  webpUrl: '/_mp-images/OrganicBeauty.webp',
  title: 'Organic Beauty'
}, {
  imageUrl: '/_mp-images/ArtisanalFood.png',
  webpUrl: '/_mp-images/ArtisanalFood.webp',
  title: 'Artisanal Food'
}, {
  imageUrl: '/_mp-images/Jewellery.png',
  webpUrl: '/_mp-images/Jewellery.webp',
  title: 'Jewellery'
}, {
  imageUrl: '/_mp-images/Clothing.png',
  webpUrl: '/_mp-images/Clothing.webp',
  title: 'Clothing'
}, {
  imageUrl: '/_mp-images/Footwear.png',
  webpUrl: '/_mp-images/Footwear.webp',
  title: 'Footwear'
}, {
  imageUrl: '/_mp-images/Accessories.png',
  webpUrl: '/_mp-images/Accessories.webp',
  title: 'Fashion Accessories'
}, {
  imageUrl: '/_mp-images/HomeDecor.png',
  webpUrl: '/_mp-images/HomeDecor.webp',
  title: 'Home Decor'
}, {
  imageUrl: '/_mp-images/Art.png',
  webpUrl: '/_mp-images/Art.webp',
  title: 'Art & Collectibles'
}];
export default MakerSellingCategories;